import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import useDeleteMutation from '../../../../hooks/apis/useDeleteMutaion';
import useSaveMutation from '../../../../hooks/apis/useSaveMutaion';
import useSearchMutaion from '../../../../hooks/apis/useSearchMutaion';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import { handleQuerySuccess } from '../../../../hooks/useQuriesSuccess';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { PPE_BASIC_01_Schema } from './PPE_BASIC_01_Schema';

/**
 * PPE_BASIC_01(보호구 등록/마스터) 관련 React Query 훅 모음
 */

// 보호구 등록 조회
export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(PPE_BASIC_01_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['PPEManagement', 'getPpeBasic01R1', params],
    queryFn: () =>
      apiRequest('post', Global.urls.PPEManagement.getPpeBasic01R1, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.isSuccess, query.dataUpdatedAt, query.data]);

  return query;
};

// 담당자 조회
export const useSearch2 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      PPE_BASIC_01_Schema.mapper.search2,
      context
    );
    return apiRequest('post', Global.urls.Plant.getPlaBasicR2, params);
  }, successOptions);
};

// 부서 조회
export const useSearch3 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      PPE_BASIC_01_Schema.mapper.search3,
      context
    );
    return apiRequest('post', Global.urls.Utility.getDepLast, params);
  }, successOptions);
};

// 보호구 등록 저장
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, PPE_BASIC_01_Schema.mapper.save1);

    return apiRequest(
      'post1',
      Global.urls.PPEManagement.savePpeBasic01U1,
      payload
    );
  }, options);
};

// 보호구 등록 삭제
export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, PPE_BASIC_01_Schema.mapper.delete1);
    return apiRequest(
      'post1',
      Global.urls.PPEManagement.deletePpeBasic01D1,
      payload
    );
  }, options);
};
